/**
 * R1ProductHeader - Fixed 56px sticky header (Region 1).
 *
 * Left:  product name "滑雪智能鞋垫" + subtitle "逐弯复盘教练".
 * Right: "硬件已量产" badge (pill with green dot) + honesty label
 *        "演示数据由真实算法生成" with a hover tooltip.
 *
 * Background: --bg-elevated; bottom border: --border-subtle.
 */
const TOOLTIP_TEXT =
  '初赛 demo 使用仿真数据，数据结构对齐 SkiTickData，诊断结论由 ski-algorithm-core 算法内核产出，量产硬件已存在。';

export default function R1ProductHeader() {
  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        height: '56px',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--space-lg)',
        background: 'var(--bg-elevated)',
        borderBottom: '1px solid var(--border-subtle)',
      }}
    >
      {/* Left: product name + subtitle */}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-sm)' }}>
        <span
          style={{
            fontSize: 'var(--fs-md)',
            fontWeight: 'var(--fw-semibold)',
            color: 'var(--text-primary)',
          }}
        >
          滑雪智能鞋垫
        </span>
        <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-tertiary)' }}>
          逐弯复盘教练
        </span>
      </div>

      {/* Right: hardware badge + honesty label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)' }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '2px 10px',
            borderRadius: 'var(--radius-full)',
            background: 'rgba(16, 185, 129, 0.15)',
            color: 'var(--status-good)',
            fontSize: 'var(--fs-xs)',
            fontWeight: 'var(--fw-medium)',
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: 'var(--status-good)',
            }}
          />
          硬件已量产
        </span>

        <span
          title={TOOLTIP_TEXT}
          style={{
            fontSize: 'var(--fs-xs)',
            color: 'var(--text-tertiary)',
            cursor: 'help',
            borderBottom: '1px dotted var(--text-tertiary)',
          }}
        >
          演示数据由真实算法生成
        </span>
      </div>
    </header>
  );
}
